import { apiSlice } from "../api/apiSlice";

export const assignmentMarksApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAssignmentMarks: builder.query({
      query: () => "/assignmentMark",
    }),
    getAssignmentMark: builder.query({
      query: (id) => `/assignmentMark/${id}`,
    }),
    addAssignmentMark: builder.mutation({
      query: (data) => ({
        url: "/assignmentMark",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const assignmentMark = await queryFulfilled;
          // add assignment mark cache pessimistically start
          dispatch(
            apiSlice.util.updateQueryData(
              "getAssignmentMarks",
              undefined,
              (draft) => {
                draft.push(assignmentMark?.data);
              }
            )
          );
          // add assignment mark cache pessimistically end
        } catch (err) {}
      },
    }),
    updateAssignmentMark: builder.mutation({
      query: ({ id, data }) => ({
        url: `/assignmentMark/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const assignmentMark = await queryFulfilled;
          // add assignment mark cache pessimistically start
          dispatch(
            apiSlice.util.updateQueryData(
              "getAssignmentMarks",
              undefined,
              (draft) => {
                const indexToUpdate = draft.find((q) => q.id == arg.id);
                indexToUpdate.mark = assignmentMark?.data?.mark;
                indexToUpdate.status = assignmentMark?.data?.status;
              }
            )
          );
          // add assignment mark cache pessimistically end
        } catch (err) {}
      },
    }),
    deleteAssignmentMark: builder.mutation({
      query: (id) => ({
        url: `/assignmentMark/${id}`,
        method: "DELETE",
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        // optimistic cache update start
        const pathResult = dispatch(
          apiSlice.util.updateQueryData(
            "getAssignmentMarks",
            undefined,
            (draft) => {
              const indexToRemove = draft.findIndex((q) => q.id === arg);
              if (indexToRemove !== -1) {
                draft.splice(indexToRemove, 1);
              }
            }
          )
        );
        // optimistic cache update end

        try {
          await queryFulfilled;
        } catch (err) {
          pathResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetAssignmentMarksQuery,
  useGetAssignmentMarkQuery,
  useAddAssignmentMarkMutation,
  useUpdateAssignmentMarkMutation,
  useDeleteAssignmentMarkMutation,
} = assignmentMarksApi;
